import React from 'react';
import { StarIcon, UsersIcon, AwardIcon, ShieldCheckIcon } from 'lucide-react';
export function LuxuryValidationSection() {
  return <section className="relative z-10 py-4 md:py-6 px-4 bg-gradient-to-b from-[#130d30] to-[#1a1040] border-y border-[#F5C842]/10" data-id="element-91">
      <div className="max-w-5xl mx-auto" data-id="element-92">
        <div className="text-center mb-6" data-id="element-93">
          <h2 className="text-xl md:text-2xl font-black text-white mb-2" data-id="element-94">
            Respaldado por{' '}
            <span className="text-gold-gradient" data-id="element-95">
              +1.000 Astrólogos profesionales
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-96">
          {/* Card 1 */}
          <div className="bg-[#1a1030]/80 backdrop-blur-sm border border-[#F5C842]/20 rounded-xl p-4 flex flex-col items-center text-center" data-id="element-97">
            <div className="w-10 h-10 rounded-full bg-[#F5C842]/10 flex items-center justify-center mb-2 border border-[#F5C842]/30" data-id="element-98">
              <UsersIcon className="w-5 h-5 text-[#F5C842]" data-id="element-99" />
            </div>
            <h3 className="text-2xl font-black text-white" data-id="element-100">+1.000</h3>
            <p className="text-[#F5C842] font-bold text-xs uppercase tracking-wider" data-id="element-101">
              Profesionales
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#1a1030]/80 backdrop-blur-sm border border-[#F5C842]/30 rounded-xl p-4 flex flex-col items-center text-center relative overflow-hidden" data-id="element-102">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#F5C842] to-transparent opacity-50" data-id="element-103"></div>
            <div className="flex items-center gap-0.5 mb-2 mt-1" data-id="element-104">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-105" />)}
            </div>
            <h3 className="text-2xl font-black text-white" data-id="element-106">9.8/10</h3>
            <p className="text-[#F5C842] font-bold text-xs uppercase tracking-wider" data-id="element-107">
              Calificación
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#1a1030]/80 backdrop-blur-sm border border-[#F5C842]/20 rounded-xl p-4 flex flex-col items-center text-center" data-id="element-108">
            <div className="w-10 h-10 rounded-full bg-[#F5C842]/10 flex items-center justify-center mb-2 border border-[#F5C842]/30" data-id="element-109">
              <AwardIcon className="w-5 h-5 text-[#F5C842]" data-id="element-110" />
            </div>
            <h3 className="text-base font-black text-white mt-1" data-id="element-111">
              +335 Páginas
            </h3>
            <p className="text-[#F5C842] font-bold text-xs uppercase tracking-wider" data-id="element-112">
              Recursos Completos
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-[#1a1030]/80 backdrop-blur-sm border border-[#F5C842]/20 rounded-xl p-4 flex flex-col items-center text-center" data-id="element-113">
            <div className="w-10 h-10 rounded-full bg-[#F5C842]/10 flex items-center justify-center mb-2 border border-[#F5C842]/30" data-id="element-114">
              <ShieldCheckIcon className="w-5 h-5 text-[#F5C842]" data-id="element-115" />
            </div>
            <h3 className="text-base font-black text-white mt-1" data-id="element-116">
              100% Probado
            </h3>
            <p className="text-[#F5C842] font-bold text-xs uppercase tracking-wider" data-id="element-117">
              Método Exacto
            </p>
          </div>
        </div>
      </div>
    </section>;
}